import React from 'react';
import { Code } from '@components/sanity/serializers/code';
import classNames from 'classnames';
import Image from 'next/legacy/image';

type TProps = {
  imagePosition?: 'left' | 'right';
  signIn: string;
};

export const SimpleSignIn: React.FC<TProps> = props => {
  let { imagePosition } = props;
  const { signIn } = props;
  if (!imagePosition) {
    imagePosition = 'right';
  }

  return (
    <>
      <div className="lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8">
        <div
          className={classNames(
            'mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:px-0',
            imagePosition === 'right' ? 'lg:col-start-1' : 'lg:col-start-2'
          )}
        >
          <div>
            <div className="mt-6">
              <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                {`<SignIn />`}
              </h2>
              <p className="text mt-4 text-gray-500">
                Your sign-in flow is the only thing sitting between existing
                users and your application—it&apos;s absolutely critical that
                users can complete the process quickly.
              </p>
              <Code language="jsx" theme="dark" highlightedLines={undefined}>
                {signIn}
              </Code>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            'mx-auto flex max-w-xl items-center justify-center px-8',
            imagePosition === 'right' ? 'lg:col-start-2' : 'lg:col-start-1'
          )}
        >
          <Image
            className="w-full object-cover"
            src="/images/components/sign-in-full.svg"
            alt="sign-in-full"
            width={496}
            height={334}
          />
        </div>
      </div>
    </>
  );
};

SimpleSignIn.defaultProps = {
  imagePosition: undefined
};

export default SimpleSignIn;
